import { Link, useNavigate, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';
import Paginations from '../../../components/paginaton/Paginations';

const DeliverySettlement = () => {
  const [gridData, setGridData] = useState([]);
  const { branchId } = useParams();
  const [loading, setLoading] = useState(true);
  const [totalPages , setTotalPages] = useState(null)
  const navigate = useNavigate();
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    firstName: "",
    lastName: "",
    mobile: 0,
    code: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });

  const getGridData = async () => {
    const resp = await apiMethod.getDeliveries(filterModel.branchId, filterModel.size, filterModel.part, filterModel.firstName, filterModel.lastName, filterModel.mobile, filterModel.code)
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      setTotalPages(resp.total)
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.firstName = "";
    filterModel.lastName = "";
    filterModel.mobile = 0;
    filterModel.code = "";
    setFilterModel({ ...filterModel })
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  // const movePagerPart = (isForward) => {
  //   if (isForward) {
  //     if (filterModel.parts < filterModel.part + 1) {
  //       return false;
  //     }
  //     callPager(filterModel.part + 1);
  //   } else {
  //     if (filterModel.part === 1) {
  //       return false;
  //     }
  //     callPager(filterModel.part - 1);
  //   }
  // };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  // const makePagerItems = () => {
  //   let pages = [];
  //   for (let i = 1; i <= filterModel.parts; i++) {
  //     pages.push(
  //       <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
  //         <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
  //           {i}
  //         </a>
  //       </li>
  //     );
  //   }
  //   return pages;
  // };

  const renderDeliveries = () => {
    return (
      <>
        {loading ? <Preloading /> :
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/#2`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#2`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                مدیریت پیک ها
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>مدیریت پیک ها
                <a href={`/sale/${branchId}/softwareGuide/#section14`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-3'>
                    <label htmlFor="funit" className="form-label">نام</label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: 'rtl', textAlign: 'right' }}
                      value={filterModel.firstName}
                      onChange={(e) => { setFilterModel({ ...filterModel, firstName: e.target.value, part: 1 }) }}
                    />
                  </div>
                  <div className='col-12 col-md-3'>
                    <label htmlFor="funit" className="form-label"> نام‌خانوادگی</label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: 'rtl', textAlign: 'right' }}
                      value={filterModel.lastName}
                      onChange={(e) => { setFilterModel({ ...filterModel, lastName: e.target.value, part: 1 }) }}
                    />
                  </div>
                  <div className='col-12 col-md-3'>
                    <label htmlFor="fstatus" className="form-label">کد پرسنلی</label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: 'rtl', textAlign: 'right' }}
                      value={filterModel.code}
                      onChange={(e) => { setFilterModel({ ...filterModel, code: e.target.value, part: 1 }) }}
                    />
                  </div>
                  <div className='col-12 col-md-3 ps-0' style={{ marginTop: '37px' }}>
                    <button type='button' className='btn btn-purple me-1'
                      onClick={() => { searchItem() }}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button type='button' className='btn btn-outline-info'
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">نام</th>
                      <th scope="col vertical-center">کد پرسنلی</th>
                      <th scope="col vertical-center">کدملی</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((delivery, index) => (
                      <tr key={delivery.id}>
                        <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th>
                        <td>{delivery.firstname} {' '} {delivery.lastname}</td>
                        <td>{delivery.employeeCode}</td>
                        <td>{delivery.nCode}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-greenLight ms-2"
                            onClick={() => navigate(`/sale/${branchId}/deliverySettlement/settlementOfAccounts/${delivery.userId}`)}
                          >
                            تسویه حساب
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-purple"
                            onClick={() => navigate(`/sale/${branchId}/deliverySettlement/deliveryPos/${delivery.userId}`)}
                          >
                            تخصیص پوز
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* {filterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                } */}
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPages}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    )
  };

  return (
    <>
      {renderDeliveries()}
    </>
  );
}

export default DeliverySettlement;